import { Component, Input, Output } from "@angular/core";
import { ReflectionQuestion, ReflectionQuestionType } from "@webapp/reflections/models/reflections.models";
import { FormArray, FormGroup } from "@angular/forms";
import { EventEmitter } from "@angular/core";
import { DeleteReflectionQuestionType, UpdateReflectionQuestionType } from "@webapp/reflections/models/manage-reflections.models";

@Component({
  selector: "manage-reflection-questions",
  templateUrl: "./manage-question.component.html",
  styleUrls: ["./manage-question.component.less"],
})
export class ManageReflectionQuestionsComponent {
  @Input() public questions: ReflectionQuestion<ReflectionQuestionType>[];
  @Input() public formGroup: FormGroup;
  @Output() public onQuestionUpdated = new EventEmitter<UpdateReflectionQuestionType>();
  @Output() public onQuestionDeleted = new EventEmitter<DeleteReflectionQuestionType>();

  public hoveredIndex: number;

  get getQuestions(): FormArray {
    return this.formGroup.controls.questions as FormArray;
  }

  public updateQuestion(question: UpdateReflectionQuestionType): void {
    if (this.formGroup.controls.questions.status === "VALID") {
      this.onQuestionUpdated.emit(question);
    }
  }

  public deleteQuestion(params: DeleteReflectionQuestionType): void {
    this.onQuestionDeleted.emit({ questionId: params.questionId, index: params.index });
  }

  public onHover(index: number): void {
    this.hoveredIndex = index;
  }
}
